import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import AdminOrderList from '@/views/admin/AdminOrderList'
import CustomerOrderList from '@/views/customer/CustomerOrderList'
import OrderDetail from '@/views/OrderDetail'
import AccountCreate from '@/views/account/AccountCreate'
import AccountList from '@/views/account/AccountList'
import AdminOrderCreate from '@/views/admin/AdminOrderCreate'
import AdminOrderStatus from '@/views/admin/AdminOrderStatus'
import AdminOrderImport from '@/views/admin/AdminOrderImport'
import AdminLoginLog from '@/views/admin/AdminLoginLog'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/login' }, // 根路径跳登录
    { path: '/login', component: Login, meta: { requiresAuth: false } }, // 登录页无需权限
    { path: '/admin-order-list', component: AdminOrderList, meta: { requiresAuth: true } },
    { path: '/account/list', component: AccountList, meta: { requiresAuth: true } },
    { path: '/account/create', component: AccountCreate, meta: { requiresAuth: true } },
    { path: '/admin/order-status', component: AdminOrderStatus, meta: { requiresAuth: true } },
    { path: '/admin/order-import', component: AdminOrderImport, meta: { requiresAuth: true } },
    { path: '/admin/order-create', component: AdminOrderCreate, meta: { requiresAuth: true } },
    { path: '/admin/login-log', component: AdminLoginLog, meta: { requiresAuth: true } },
    { path: '/customer-order-list', component: CustomerOrderList, meta: { requiresAuth: true } },
    { path: '/order/detail', component: OrderDetail, meta: { requiresAuth: true } }
  ]
})

// 完善路由守卫，避免无限重定向
router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
  // 登录页直接放行
  if (to.path === '/login') {
    next();
    return;
  }
  // 需权限的页面，判断是否登录
  if (to.meta.requiresAuth) {
    if (userInfo.username) {
      next();
    } else {
      // 未登录跳登录，避免循环重定向
      next('/login');
    }
  } else {
    next();
  }
})

export default router